export const editor = {
  toolbar: {
    background: "{content.background}",
    borderColor: "{form.field.border.color}",
    borderRadius: "{content.border.radius}",
  },
  toolbarItem: {
    color: "{text.caption}",
    hoverColor: "{text.body}",
    activeColor: "{text.body}",
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    padding: "{list.padding}",
  },
  overlayOption: {
    focusBackground: "{list.option.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}",
  },
  content: {
    background: "{content.background}",
    borderColor: "{form.field.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
  },
  extend: {
    ui: {
      container: {
        shadow: "{form.field.shadow}",
        disabledBackground: "{form.field.disabled.background}",
      },
      content: {
        paddingX: "{form.field.padding.x}",
        paddingY: "{form.field.padding.y}",
      },
      label: {
        color: "{floatlabel.color}",
        fontWeight: "{floatlabel.font.weight}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-editor .ql-toolbar {
      font-family: inherit;
    }

    .p-editor .ql-container.ql-disabled > .ql-editor {
      background-color: ${dt("editor.ui.container.disabled.background")};
    }

    .p-editor .p-editor-container {
      box-shadow: ${dt("editor.ui.container.shadow")};
    }

    .p-editor .p-editor-content .ql-editor {
      padding-inline: ${dt("editor.ui.content.padding.x")};
      padding-block: ${dt("editor.ui.content.padding.y")};
    }

    .p-editor .p-editor-toolbar label {
      color: ${dt("editor.ui.label.color")};
      font-weight: ${dt("editor.ui.label.font.weight")};
    }
  `,
};
